document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.coto-video').forEach(video => {
        video.querySelector('.coto-video-play')?.addEventListener('click', () => {
            const frame = document.createElement('iframe');
            frame.src = video.dataset.videoSrc;
            frame.title = video.dataset.videoTitle;
            frame.allow = 'autoplay; encrypted-media; picture-in-picture; web-share';
            frame.allowFullscreen = true;
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            video.replaceChildren(frame);
            frame.focus();

            // Google enhanced measurement waits for this supported API callback.
            // Load it only after playback is requested; keep Google's existing
            // callback and event handling intact to avoid duplicate video events.
            if (!window.YT && ![...document.scripts].some(script =>
                /^https:\/\/www\.youtube\.com\/(iframe|player)_api(?:[?#]|$)/.test(script.src))) {
                const api = document.createElement('script');
                api.src = 'https://www.youtube.com/iframe_api';
                api.async = true;
                document.head.append(api);
            }
        }, {once: true});
    });
});
